
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "../Loading";
import {jwtDecode} from "jwt-decode";

const ProtectedRoute = ({ roles = [] }) => {
  const { token, isAuthenticated, loading } = useAuth();
  const { lang } = useParams();

  if (loading) return <Loading />;

  if (!isAuthenticated) return <Navigate to={`/lang/${lang}/login`} replace />;

  const role = token ? Number(jwtDecode(token).role) : null;

  if (roles.length > 0 && !roles.includes(role)) {
    return <Navigate to={`/lang/${lang}/unauthorized`} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
